module.exports = __webpack_public_path__ + "media/ecom/ArrowRight-fb6a73cb.svg";